import { createFileRoute } from '@tanstack/react-router'
import PositiveImageryArchive from "@/components/Exercises/Positive-Imagery/archivePage/PositiveImageryArchive";

export const Route = createFileRoute(
  '/(content)/adults/exercises/(shared)/positive-imagery/archive',
)({
  component: RouteComponent,
})

function RouteComponent() {
  return <PositiveImageryArchive />;
}
